import get from 'lodash/get';

import getParent from '../../selectors';
const getDatasetStore = state => getParent(state).dataset;

export const getSummary = state => getDatasetStore(state).summary;
export const getNumericalSummary = state => getSummary(state) ? getSummary(state).numericalSummary : null;
export const getCategoricalSummary = state => getSummary(state) ? getSummary(state).categoricalSummary : null;

export const getNumericalSummaryByName = (state, name) =>
  get(getNumericalSummary(state), name);

export const getDomainValueByName = (state, name) => {
  const summaryValue = getNumericalSummaryByName(state, name);
  if (summaryValue) {
    const { max, min } = summaryValue;
    return { max, min };
  }
  return {};
};
